<template>
  <div class="has-bg-white is-radius is-bordered" :class="{'is-margin-bottom': !mapCard}">
    <header class="card-header is-border-bottom" v-if="mapCard">
      <p class="card-header-title is-size-3">
        {{ stock.name }}
        <span v-if="isAdmin" class="tag is-xsmall is-margin-left-small" :class="tagColor(stock.program_status)">{{stock.program_status | workflowLabel}}</span>
      </p>
    </header>
    <div class="columns is-gapless">
      <div class="column "
           :class="mapCard ? 'is-one-third is-4' : 'is-narrow is-border-left is-border-top is-border-bottom has-bg-light'"
           style="width:270px; max-width:33%"> <!-- 274 sous FF && 270 sous chrome :( -->
        <router-link :to="{name: 'ProgramVue', params: {id: programPk}, query: {returnId: programPk, page: currentProgramPage}}" class="is-block">
          <figure class="image is-4by3 is-margin-auto has-tag has-tag--top-leftout" :class="{'is-disabled': stock.program_status === 'draft'}">
            <div class="tags columns is-column is-align-items-flex-start" v-if="!mapCard">
              <span v-if="stock.progress_step" class="tag is-info is-radiusless">{{programStepProgressLabel(stock.progress_step)}}</span>
              <span v-if="stock.is_exclusive" class="tag is-exclusif is-radiusless">Exclusivité</span>
              <span v-for="(t, i) in stock.tags.slice(0, 3)" class="tag is-annonce is-radiusless"
                    :key="i" v-if="stock.tags && stock.tags.length">{{t | truncate}}</span>
            </div>
            <div v-if="stock.picture && stock.picture.path">
              <img :src="stock.picture | smallImage">
            </div>
            <div v-else>
              <img :src="programPicturePlaceholder| smallImage">
            </div>
          </figure>
          <div class="columns has-bg-annonce is-vcentered" v-if="!stock.is_optionable && !mapCard">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
              <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
            </div>
            <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-white is-italic is-size-6 has-text-weight-medium">
                <span>Non optionnable</span>
              </div>
            </div>
          </div>
          <router-link v-if="mapCard" :to="{name: 'ProgramVue', params: {id: programPk}, query: {returnId: programPk, page: currentProgramPage}}"
                       class="button is-primary is-fullwidth is-margin-top-xsmall">Fiche programme</router-link>
        </router-link>
      </div>
      <div class="column " :class="mapCard ? 'is-two-thirds is-8' : 'is-border'">
        <div class="columns is-gapless is-padding-left is-align-items-flex-start">
          <div class="column is-padding-top-small">
            <router-link :to="{name: 'ProgramVue', params: {id: programPk}, query: {returnId: programPk, page: currentProgramPage}}" class="title is-3 is-marginless is-inline-flex is-vcentered" v-if="!mapCard">
              <b>{{stock.name}}</b>
              <span class="icon has-text-grey tooltip is-tooltip-right is-padding-left-small is-size-5"
                    data-tooltip="Flux promoteur" v-if="isDistributeurMode && stock.from_flux && !isExternal">
                <i class="fas fa-rss"></i>
              </span>
            </router-link>
            <div class="title is-7 is-marginless is-padding-top-xsmall" v-if="isAdmin && !mapCard">
              <div class="has-text-grey is-size-6"> 
                Date de création : {{stock.created_on | prettyDate}}
                <span v-if="isAdmin" class="tag is-xsmall is-margin-left-small" :class="tagColor(stock.program_status)">{{stock.program_status | workflowLabel}}</span>
              </div>
            </div>
          </div>
          <div class="column is-narrow is-border-left is-border-bottom">
            <display-button-list v-if="!mapCard && !multiselection" :buttons="buttonList" :data="stock"
                                 :classes="'is-square is-ghost is-grey is-inverted is-radiusless'">
            </display-button-list>
            <multiselect-button v-else-if="!mapCard && multiselection"
                                :data="stock"
                                :is-checked="checkedItem(stock.program)"
                                :multiselection="multiselection"
                                :multiselectionClass="'is-square is-info is-radiusless'"
                                @selected="selected($event, stock.program)">
            </multiselect-button>
          </div>
        </div>
        <div class="is-margin-top-small is-size-5 is-padding-right is-padding-left">
          <p>
            <span class="icon is-small is-margin-right-xsmall"><i class="far fa-landmark"></i></span>
            Dispositif(s) : <b v-if="taxDispositifs">{{taxDispositifs}}</b><span v-else>Aucun</span>
            <span class="is-margin-left-xsmall" v-if="displayRemuneration && isAdmin">
               - Tx Comm. : <b v-if="stock.remuneration">{{stock.remuneration|prettyPrice}} %</b><span v-else>NC</span>
            </span>
          </p>
          <p class="is-padding-top-xsmall">
            <span class="icon is-small is-margin-right-xsmall" :class="actableStatus.color"><i class="fas" :class="actableStatus.icon"></i></span>
            <span :class="actableStatus.color">{{actabilityTerm}}</span>
            <span class="is-padding-left-xsmall">
              - Livraison :
              <b v-if="stock.date_livraison">{{stock.date_livraison | prettyTrimestreLong}}</b>
              <span v-else>NC</span>
            </span>
          </p>
          <p class="is-size-6 is-padding-top-xsmall">
            <span v-if="fromTo.toType && (fromTo.fromType !== fromTo.toType)">Du {{fromTo.fromType}} au {{fromTo.toType}} - </span>
            <span v-else-if="fromTo.fromType">{{fromTo.fromType}} - </span>
            <span v-if="fromTo.toPrice && (fromTo.fromPrice !== fromTo.toPrice)">de {{fromTo.fromPrice | prettyPrice}} {{$currency}} à {{fromTo.toPrice | prettyPrice}} {{$currency}}</span>
            <span v-else-if="fromTo.fromPrice">à partir de {{fromTo.fromPrice | prettyPrice}} {{$currency}}</span>
            <br v-if="!isExternal && stock.promoteur && isDistributeurMode && mapCard">
            <span v-if="!isExternal && stock.promoteur && isDistributeurMode">
              <span class="is-padding-left-xsmall" v-if="!mapCard"> - </span>
              Promoteur : <router-link :to="{name: 'PromoteurVue', params: {id: stock.promoteur}}" class="is-underline" v-if="isAdmin || isEditor"><b>{{stock.promoteur_name}}</b></router-link>
              <span v-else>{{stock.promoteur_name}}</span>
            </span>
          </p>
          <div class="truncate">
            <p class="is-size-6">
              <b>Adresse : </b><span v-if="address">{{address.line1}} {{address.zip_code}} {{address.city}}</span><span v-else>NC</span>
            </p>
          </div>
          <div class="columns is-vcentered" v-if="!stock.is_optionable && mapCard">
            <div class="column is-narrow is-paddingless-left is-padding-top-small is-paddingless-bottom is-padding-right-xsmall">
              <span class="icon has-text-annonce"><i class="fas fa-engine-warning fa-lg"></i></span>
            </div>
            <div class="column is-paddingless-left is-padding-top-small is-paddingless-bottom">
              <div class="has-text-annonce is-italic is-size-6 has-text-weight-medium">
                <span>Non optionnable (contacter responsable programme)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="is-margin-top"></div>
        <!-- <router-link :to="{name: 'StockLots', query: {program: stock.program, lot_type: [info.type]}}" -->
        <router-link :to="{name: 'StockLots', query: {program: stock.program}, query: {returnId: programPk, page: currentProgramPage}}"
                    class="columns is-gapless is-padding-right is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border--light"
                    :class="{'has-text-grey has-bg-light': stock.program_status === 'draft'}"
                    v-if="lotResume && priceBySize && info.cheapest_lot && info.cheapest_lot.sale_price" v-for="(info, i) in priceBySize" :key="i">
          <div class="column is-4" :class="mapCard ? 'is-3-fullhd' : 'is-2-fullhd'">
            <b v-if="info.type === 'parking'">Parking</b>
            <b v-else>Lot {{ lotTypeLabel(info.type) }}</b>
          </div>
          <div class="column is-6" :class="mapCard ? 'is-6-fullhd is-size-6' : 'is-4-fullhd'">
            <span v-if="info.highest_lot && info.cheapest_lot && (info.cheapest_lot.sale_price !== info.highest_lot.sale_price)">
              de {{info.cheapest_lot.sale_price | prettyPrice}} {{$currency}} à {{info.highest_lot.sale_price | prettyPrice}} {{$currency}}
            </span>
            <span v-else-if="info.cheapest_lot">à partir de {{info.cheapest_lot.sale_price | prettyPrice}} {{$currency}}</span>
          </div>
          <div class="column is-2" :class="mapCard ? 'is-3-fullhd' : 'is-2-fullhd'">
            <div class="">{{info.count}} lot<span v-if="info.count > 1">s</span></div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { DefaultValues, GenericList } from '../../mixins'
  import { isEmpty, orderBy, last, head, uniq, compact } from 'lodash'

  export default {
    name: 'StockCard',
    mixins: [DefaultValues, GenericList],
    data () {
      return {
        service: this.$api.programService,
        buttonList: [
          {
            icon: 'fas fa-file-invoice',
            text: 'Fiche programme',
            action: (id, data) => {
              this.$router.push({name: 'ProgramVue', params: {id: data.program}, query: {returnId: data.program, page: this.currentProgramPage}})
            }
          },
          {
            icon: 'fas fa-edit',
            text: 'Modifier fiche programme',
            needProfile: ['admin', 'editor'],
            action: (id, data) => {
              this.$router.push({name: 'ProgramEdit', params: {id: data.program}, query: {returnId: data.program, page: this.currentProgramPage}})
            }
          },
          {
            icon: 'fas fa-folders',
            text: 'Gestions documents',
            needProfile: ['admin', 'editor'],
            action: (id, data) => {
              this.$router.push({name: 'ProgramDocumentEdit', params: {id: data.program}, query: {returnId: data.program, page: this.currentProgramPage}})
            }
          },
          {
            action: (id, data) => {
              this.deleteItem(data.program)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer programme',
            needProfile: ['admin']
          }
        ]
      }
    },
    props: {
      stock: {
        type: Object,
        required: true
      },
      multiselection: {
        type: Boolean,
        default: false
      },
      mapCard: {
        type: Boolean,
        default: false
      },
      selectedItems: {
        type: Array,
        default: () => []
      },
      currentProgramPage: Number
    },
    computed: {
      ...mapState(['configs']),
      ...mapGetters(['isAdmin', 'isManager', 'isDistributeurMode', 'displayRemuneration', 'isExternal', 'isEditor']),
      taxDispositifs () {
        if (!this.stock || !this.stock.tax_dispositifs || !this.stock.tax_dispositifs.length) return
        if (!this.taxDispositifsData) return
        let data = uniq(compact(this.stock.tax_dispositifs.map(x => {
          if (this.taxDispositifsData[x]) {
            return this.taxDispositifsData[x].label
          }
        })))
        return data.join(', ')
      },
      programPk () {
        if (this.stock && this.stock.program) {
          return this.stock.program
        } else return null
      },
      lotResume () {
        return this.stock.lot_resume
      },
      priceBySize () {
        if (!this.lotResume || !this.lotResume.price_by_size) return
        let data = []
        for (let [key, value] of Object.entries(this.lotResume.price_by_size)) {
          data.push({
            type: key,
            ...value
          })
        }
        return orderBy(data, 'type', 'asc')
      },
      fromTo () {
        let fromTo = {fromType: null, toType: null, fromPrice: null, toPrice: null}
        let first = head(this.priceBySize)
        let end = last(this.priceBySize)
        if (first && first.type) fromTo.fromType = first.type
        if (end && end.type) fromTo.toType = end.type
        if (first && first.cheapest_lot && first.cheapest_lot.sale_price) {
          fromTo.fromPrice = first.cheapest_lot.sale_price
        }
        if (end && end.highest_lot && end.highest_lot.sale_price) {
          fromTo.toPrice = end.highest_lot.sale_price
        }
        return fromTo
      },
      address () {
        if (isEmpty(this.stock.address) === false) {
          return this.stock.address
        } else {
          return null
        }
      },
      actableStatus () {
        let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
        let date = new Date()
        let currentTrim = `${date.getFullYear()}${trim.findIndex(x => x.includes(date.getMonth())) + 1}`
        if (!this.stock.date_actabilite) {
          return {icon: 'fa-question-circle', color: 'has-text-black'}
        } else if (currentTrim > this.stock.date_actabilite) {
          return {icon: 'fa-check-circle', color: 'has-text-green3'}
        } else if (currentTrim <= this.stock.date_actabilite) {
          return {icon: 'fa-times-circle', color: 'has-text-warning'}
        }
      },
      actabilityTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'Actable',
          MAR: 'Titre foncier'
        }
        return term[this.configs.COUNTRY]
      }
    },
    methods: {
      tagColor (value) {
        const COLORS = {
          'private': 'is-private',
          'available': 'is-disponible',
          'draft': 'is-draft',
          'archived': 'is-draft'
        }
        return COLORS[value]
      },
      checkedItem (id) {
        return this.selectedItems.includes(id)
      },
      selected (v, id) {
        v.data = id
        this.$emit('selectItem', v)
      },
      afterSuccessDelete () {
        this.$emit('reload')
      }
    },
    mounted () {
      this.$emit('update-card-content')
    },
    updated () {
      this.$emit('update-card-content')
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/stock/StockProgramCard.vue